module.exports = __webpack_public_path__ + "img/Wp_2094.be1747f8.png";